import {STOPPAGE_ANALYSIS_SUB_PATH} from '@features/stoppage-analysis'
import {PLANT_DOWNTIME} from '@hconnect/common/consts'
import {STATUS} from '@hconnect/common/hproduce/config/hproduce'

import {
  DOWNTIME,
  PERFORMANCE,
  LOCATION_KPI,
  PLANT_KPI,
  LOCATION_KPI_STATUS,
  PLANT_KPI_STATUS,
  PLANT_DOWNTIME_STATS,
  PLANT_DOWNTIME_STOPPAGES,
  PLANT_DOWNTIME_STOPPAGES_DETAILS,
  PLANT_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE,
  EXPERT_SYSTEM_USAGE_RATE
} from '../../shared/routes/routes'

export {
  DOWNTIME,
  PERFORMANCE,
  LOCATION_KPI,
  PLANT_KPI,
  LOCATION_KPI_STATUS,
  PLANT_KPI_STATUS,
  PLANT_DOWNTIME,
  PLANT_DOWNTIME_STATS,
  PLANT_DOWNTIME_STOPPAGES,
  PLANT_DOWNTIME_STOPPAGES_DETAILS,
  PLANT_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE,
  EXPERT_SYSTEM_USAGE_RATE,
  STATUS
}

// Extended routes - Status
export const GLOBAL_KILN_STATUS = STATUS
export const AREA_KPI_STATUS = `${STATUS}/area/:locationId`
export const STOPPAGE_ANALYSIS_STATUS = `${STATUS}/plant/:plantId/${STOPPAGE_ANALYSIS_SUB_PATH}`

// Extended routes - Performance
export const GLOBAL_KILN_PERFORMANCE = PERFORMANCE
export const AREA_KPI = `${PERFORMANCE}/area/:locationId`
export const PLANT_PERFORMANCE = `${PERFORMANCE}/plant/:plantId`
export const STOPPAGE_ANALYSIS = `${PLANT_PERFORMANCE}/${STOPPAGE_ANALYSIS_SUB_PATH}`

// Error pages
export const UNAUTHORIZED = '/unauthorized'
export const ERROR_403 = '/error403'
export const ERROR_500 = '/error500'
